module.exports = __webpack_public_path__ + "static/media/prize-container.bb03acb5.png";